<template lang="html">
<div class="content-wrapper">
    <div class="row">
        <div class="col-sm-12 grid-margin">
            <div class="row">
                <div class="col-sm-12 pr-0">
                    <div class="d-lg-flex">
                        <h3 class="text-light font-weight-bold mb-0 mr-5">{{lang=="ru"?"Настройки профиля":"Account settings"}}</h3>
                        <span style='margin-left: auto;'>
                            <!-- <h3 class="font-weight-bold" style='display: inline;'>{{lang=="ru"?"TradingAmmo баланс":"TradingAmmo balance "}}: {{$parent.balance}}$</h3> -->
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 grid-margin">
            <div class="card mb-3" style="margin-bottom:0.7rem !important">
              <div class="card-body px-4">
                  <div v-if="this.$parent.login_type=='google'" class="card-title">
                      {{lang=="ru"?"Поменять пароль":"Create password"}}
                  </div>
                  <div v-if="this.$parent.login_type=='site'" class="card-title">
                      {{lang=="ru"?"Поменять пароль":"Update password"}}
                  </div>
                  <h6 class="font-weight-light" style='color: red' :class='passwordUpdateError ? "" : "invisible"'>{{passwordUpdateError}}</h6>
                  <div class="form-group row">
                      <label v-if="this.$parent.login_type=='site'" for="old-pass" class="col-sm-4 col-form-label">{{lang=="ru"?"Текущий пароль:":"Current password:"}}</label>
                      <div v-if="this.$parent.login_type=='site'" class="col-sm-8">
                          <div class="input-group">
                              <input type="password" class='form-control' id='old-pass' v-model='password.old'>
                          </div>
                      </div>
                      <label for="new-pass" class="col-sm-4 col-form-label">{{lang=="ru"?"Новый пароль:":"New password:"}}</label>
                      <div class="col-sm-8">
                          <div class="input-group">
                              <input type="password" class='form-control' id='new-pass' v-model='password.new'>
                          </div>
                      </div>
                      <label for="new-pass2" class="col-sm-4 col-form-label">{{lang=="ru"?"Повторите новый пароль:":"Repeat new password:"}}</label>
                      <div class="col-sm-8">
                          <div class="input-group">
                              <input type="password" class='form-control' id='new-pass2' v-model='password.new2'>
                          </div>
                      </div>
                  </div>
                  <button type="button" class='btn btn-primary pull-right' name="button" @click="saveNewPassword()">{{lang=="ru"?"Обновить":"Save"}}</button>
              </div>
          </div>
            <div class="card" style="margin-bottom:0.7rem">
                <div class="card-body px-4">
                    <div class="card-title">
                       {{lang=="ru"?"Уведомления":"Alert preferences"}}
                    </div>
                    <div class="form-group row">
                        <label for="amount-input" class="col-sm-4 col-form-label">{{lang=="ru"?"Почта":"Email"}}:</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <input type="text" class='form-control' id='amount-input' v-model='$parent.alert_email'>
                            </div>
                        </div>
                        <label class="col-sm-4 col-form-label">Telegram:</label>
                        <div class="col-sm-8">
                            <div class="input-group" v-if='$parent.telegram_name'>
                                <input type="text" class='form-control'  v-model='$parent.telegram_name'>
                                <button type="button" class='btn btn-primary pull-right' style="height: 47px" name="button" @click="disconnectTelegram()">{{lang=="ru"?"Отключить":"Unlink"}}</button>
                            </div>
                            <div class="input-group" v-else>
                                <a :href='"tg://resolve?domain=NewTradingAppBot&start=" + $parent.user_id' class='btn btn-primary w-100 mt-2'>{{lang=="ru"?"Подключите Telegram для оповещений":"Connect Telegram for alerts"}}</a>
                            </div>
                        </div>
                        <label class="col-sm-4 col-form-label" v-if="lang=='ru'">Telegram канал:</label>
                        <div class="col-sm-8" v-if="lang=='ru'">
                            <div class="input-group">
                                <a href="https://t.me/NewTradingAppBot" class='btn btn-primary w-100 mt-2'>{{lang=="ru"?"Подключите Telegram для оповещений":"Connect Telegram for alerts"}}</a>
                            </div>
                        </div>
                    </div>
                    <button type="button" class='btn btn-primary pull-right' name="button" @click="saveAlertEmail()">{{lang=="ru"?"Сохранить":"Save"}}</button>
                </div>
            </div>
            <!-- <div class="card" style="margin-bottom:0.7rem">
                <div class="card-body px-4">
                    <div class="card-title">
                    </div>
                    <div class="tg-commands" style="height: 530px">
                      <img src="https://alternative.me/crypto/fear-and-greed-index.png" alt="Latest Crypto Fear & Greed Index" style="width: 100%"/>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="vld-parent">
          <loading :active.sync="isLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>
        </div>
        <div class="col-12 col-md-4 grid-margin">
            <div class="card" style="margin-bottom:0.7rem">
                <div class="card-body px-4" style="padding-bottom: 9px">
                    <div class="card-title">
                       {{lang=="ru"?"Ключи API Binance":"Binance API Keys"}}
                    </div>
                    <div class="form-group row unlink" v-if='this.$parent.binance_keys'>
                        <p>{{lang=="ru"?"Ключи установлены":"Keys are set"}}</p>
                        <button type="button" class='btn btn-primary' name="button" @click="removeBinanceKeys()" style="margin-top: 20px">{{lang=="ru"?"Отключить":"Unlink"}}</button>
                    </div>
                    <div class="form-group row" v-else>
                        <label for="binance-pubkey" class="col-sm-4 col-form-label">{{lang=="ru"?"Открытый ключ":"Public key"}}</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <input type="password" class='form-control' id='binance-pubkey' v-model='binance.pubkey'>
                            </div>
                        </div>
                        <label for="binance-privkey" class="col-sm-4 col-form-label">{{lang=="ru"?"Закрытый ключ":"Private key"}}</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <input type="password" class='form-control' id='binance-privkey' v-model='binance.privkey'>
                            </div>
                        </div>
                    </div>
                    <div class="form-check form-check-flat form-check-primary">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" id='refill-bnb' v-model='binance.refillBnb'>
                            {{lang=="ru"?"Пополнять BNB автоматически?":"Refill BNB automatically?"}}
                            <i class="input-helper"></i></label>
                    </div>
                    <button v-if='this.$parent.binance_keys ==false' type="button" class='btn btn-primary pull-right' name="button" @click="saveBinanceKeys()" style='float:right'>{{lang=="ru"?"Обновить":"Update"}}</button>
                    <div class="form-group row" v-if='this.$parent.binance_keys'>
                        <div class="form-group row">
                            <label for="binance-pubkey" class="col-sm-8 col-form-label">{{lang=="ru"?"Test Binance API for spot trade":"Test Binance API for spot trade"}}</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    <button v-if='test_buy_binance' type="button" class='btn btn-primary' name="button" @click="key_test()">{{lang=="ru"?"Test for Buy":"Test for Buy"}}</button>
                                    <button v-else type="button" class='btn btn-primary' name="button" @click="key_test()">{{lang=="ru"?"Close test":"Close test"}}</button>
                                </div>
                            </div>
                            <label for="binance-privkey" class="col-sm-8 col-form-label">{{lang=="ru"?"Test Binance API for short trade":"Test Binance API for short trade"}}</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    <button v-if='short_test_buy_binance' type="button" class='btn btn-primary' name="button" @click="short_key_test('binance')">{{lang=="ru"?"Test for Sell":"Test for Sell"}}</button>
                                    <button v-else type="button" class='btn btn-primary' name="button" @click="short_key_test('binance')">{{lang=="ru"?"Close test":"Close test"}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" style="margin-bottom:0.7rem">
                <div class="card-body px-4" style="padding-bottom: 9px">
                    <div class="card-title">
                       {{lang=="ru"?"Краткая инструкция, как включить автоторговлю:":"Brief instructions on how to enable autotrading:"}}
                    </div>
                    <div class="form-group">
                        <p>{{lang == "ru" ? "1. Настройте API-ключа на выбранной бирже" : "1. Set up an API key on the selected exchange"}}</p>
                        <p>{{lang == "ru" ? "2. Вставьте их в восстановление поля на сайте" : "2. Paste them into the recovery field on the site"}}</p>
                        <p>{{lang == "ru" ? "3. Оформите подписку" : "3. Make the subscripton"}}</p>
                        <p>{{lang == "ru" ? '4. Выберите нужный алгоритм в "Ботс маркет" и откройте его' : '3. Select the desired algorithm in "Bots Market" and open it'}}</p>
                        <p>{{lang == "ru" ? '5. Пропишите нужную сумму и поставьте галочку возле "Использовать автоторговлю"' : '4. Enter the required amount and check the box next to "Use auto-trading"'}}</p>
                        <p>{{lang == "ru" ? "6. Сохраните" : "6. Save"}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 grid-margin">
            <div class="card" style="margin-bottom:0.7rem">
                <div class="card-body px-4" style="padding-bottom: 9px">
                    <div class="card-title">
                       {{lang=="ru"?"Ключи API OKX":"OKX API Keys"}}
                    </div>
                    <div class="form-group row unlink" v-if='this.$parent.OKX_keys'>
                        <p>{{lang=="ru"?"Ключи установлены":"Keys are set"}}</p>
                        <button type="button" class='btn btn-primary' name="button" @click="removeOKXKeys()" style="margin-top: 20px">{{lang=="ru"?"Отключить":"Unlink"}}</button>
                    </div>
                    <div class="form-group row" v-else>
                        <label for="OKX-pubkey" class="col-sm-4 col-form-label">{{lang=="ru"?"Открытый ключ":"Public key"}}</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <input type="password" class='form-control' id='OKX-pubkey' v-model='OKX.pubkey'>
                            </div>
                        </div>
                        <label for="OKX-privkey" class="col-sm-4 col-form-label">{{lang=="ru"?"Закрытый ключ":"Private key"}}</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <input type="password" class='form-control' id='OKX-privkey' v-model='OKX.privkey'>
                            </div>
                        </div>
                        <label for="OKX-passphare" class="col-sm-4 col-form-label">{{lang=="ru"?"Passphrase":"Passphrase"}}</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <input type="password" class='form-control' id='OKX-passphare' v-model='OKX.passphare'>
                            </div>
                        </div>
                    </div>
                    <button v-if='this.$parent.OKX_keys ==false' type="button" class='btn btn-primary pull-right' name="button" @click="saveOKXKeys()" style='float:right'>{{lang=="ru"?"Обновить":"Update"}}</button>
                    <br/>
                    <div class="form-group row" v-if='this.$parent.OKX_keys'>
                        <div class="form-group row">
                            <label for="binance-pubkey" class="col-sm-8 col-form-label">{{lang=="ru"?"Test OKX API for spot trade":"Test OKX API for spot trade"}}</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    <button v-if='test_buy_okx' type="button" class='btn btn-primary' name="button" @click="api_key_test('okx')">{{lang=="ru"?"Test for Buy":"Test for Buy"}}</button>
                                    <button v-else type="button" class='btn btn-primary' name="button" @click="api_key_test('okx')">{{lang=="ru"?"Close test":"Close test"}}</button>
                                </div>
                            </div>
                            <label for="binance-privkey" class="col-sm-8 col-form-label">{{lang=="ru"?"Test OKX API for short trade":"Test OKX API for short trade"}}</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    <button v-if='short_test_buy_okx' type="button" class='btn btn-primary' name="button" @click="short_key_test('okx')">{{lang=="ru"?"Test for Sell":"Test for Sell"}}</button>
                                    <button v-else type="button" class='btn btn-primary' name="button" @click="short_key_test('okx')">{{lang=="ru"?"Close test":"Close test"}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" style="margin-bottom:0.7rem">
                <div class="card-body px-4" style="padding-bottom: 9px">
                    <div class="card-title">
                       {{lang=="ru"?"Ключи API Kucoin":"Kucoin API Keys"}}
                    </div>
                    <div style="text-align:center; width:100%; margin-bottom: 20px">
                        <button class='btn btn-secondary' @click="change_type('s')" :style="kucoin_type=='s'?'background:#323232;':''">Spot</button>
                        <button class='btn btn-secondary' @click="change_type('f')" :style="kucoin_type=='f'?'background:#323232;':''">Futures</button>
                    </div>
                    <div v-if="this.kucoin_type=='s'">
                        <div class="form-group row unlink" v-if='this.$parent.Kucoin_keys'>
                            <p>{{lang=="ru"?"Ключи установлены":"Keys are set"}}</p>
                            <button type="button" class='btn btn-primary' name="button" @click="removeKucoinKeys()" style="margin-top: 20px">{{lang=="ru"?"Отключить":"Unlink"}}</button>
                        </div>
                        <div class="form-group row" v-else>
                            <label for="Kucoin-pubkey" class="col-sm-4 col-form-label">{{lang=="ru"?"Открытый ключ":"Public key"}}</label>
                            <div class="col-sm-8">
                                <div class="input-group">
                                    <input type="password" class='form-control' id='Kucoin-pubkey' v-model='Kucoin.pubkey'>
                                </div>
                            </div>
                            <label for="Kucoin-privkey" class="col-sm-4 col-form-label">{{lang=="ru"?"Закрытый ключ":"Private key"}}</label>
                            <div class="col-sm-8">
                                <div class="input-group">
                                    <input type="password" class='form-control' id='Kucoin-privkey' v-model='Kucoin.privkey'>
                                </div>
                            </div>
                            <label for="Kucoin-passphare" class="col-sm-4 col-form-label">{{lang=="ru"?"Passphrase":"Passphrase"}}</label>
                            <div class="col-sm-8">
                                <div class="input-group">
                                    <input type="password" class='form-control' id='Kucoin-passphare' v-model='Kucoin.passphare'>
                                </div>
                            </div>
                        </div>
                        <button v-if='this.$parent.Kucoin_keys ==false' type="button" class='btn btn-primary pull-right' name="button" @click="saveKucoinKeys()" style='float:right'>{{lang=="ru"?"Обновить":"Update"}}</button>
                        <br/>
                        <div class="form-group row" v-if='this.$parent.Kucoin_keys'>
                            <div class="form-group row " style="width: 100%">
                                <label for="Kucoin-pubkey" class="col-sm-8 col-form-label">{{lang=="ru"?"Test Kucoin API for spot trade":"Test Kucoin API for spot trade"}}</label>
                                <div class="col-sm-4">
                                    <div class="input-group">
                                        <button style="width:120px" v-if='test_buy_kucoin' type="button" class='btn btn-primary' name="button" @click="api_key_test('kucoin')">{{lang=="ru"?"Test for Buy":"Test for Buy"}}</button>
                                        <button style="width:120px" v-else type="button" class='btn btn-primary' name="button" @click="api_key_test('kucoin')">{{lang=="ru"?"Close test":"Close test"}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="this.kucoin_type=='f'">
                        <div class="form-group row unlink" v-if='this.$parent.Kucoin_future_keys'>
                            <p>{{lang=="ru"?"Ключи установлены":"Keys are set"}}</p>
                            <button type="button" class='btn btn-primary' name="button" @click="removeKucoinFutureKeys()" style="margin-top: 20px">{{lang=="ru"?"Отключить":"Unlink"}}</button>
                        </div>
                        <div class="form-group row" v-else>
                            <label for="Kucoin-furture-pubkey" class="col-sm-4 col-form-label">{{lang=="ru"?"Открытый ключ":"Future Public  key"}}</label>
                            <div class="col-sm-8">
                                <div class="input-group">
                                    <input type="password" class='form-control' id='Kucoin-furture-pubkey' v-model='KucoinFuture.pubkey'>
                                </div>
                            </div>
                            <label for="Kucoin-furture-privkey" class="col-sm-4 col-form-label">{{lang=="ru"?"Закрытый ключ":"Future Private key"}}</label>
                            <div class="col-sm-8">
                                <div class="input-furture-group">
                                    <input type="password" class='form-control' id='Kucoin-furture-privkey' v-model='KucoinFuture.privkey'>
                                </div>
                            </div>
                            <label for="Kucoin-furture-passphare" class="col-sm-4 col-form-label">{{lang=="ru"?"Passphrase":"Future Passphrase"}}</label>
                            <div class="col-sm-8">
                                <div class="input-group">
                                    <input type="password" class='form-control' id='Kucoin-furture-passphare' v-model='KucoinFuture.passphare'>
                                </div>
                            </div>
                        </div>
                        <button v-if='this.$parent.Kucoin_future_keys == false' type="button" class='btn btn-primary pull-right' name="button" @click="saveKucoinFutureKeys()" style='float:right'>{{lang=="ru"?"Обновить":"Update"}}</button>
                        <br/>
                        <div class="form-group row" v-if='this.$parent.Kucoin_future_keys'>
                            <div class="form-group row" style="width: 100%">
                                <label for="binance-privkey" class="col-sm-8 col-form-label">{{lang=="ru"?"Test Kucoin Future API for short trade":"Test Kucoin Future API for short trade"}}</label>
                                <div class="col-sm-4">
                                    <div class="input-group">
                                        <button style="width:120px" v-if='short_test_buy_kucoin' type="button" class='btn btn-primary' name="button" @click="short_key_test('kucoin')">{{lang=="ru"?"Test for Sell":"Test for Sell"}}</button>
                                        <button style="width:120px" v-else type="button" class='btn btn-primary' name="button" @click="short_key_test('kucoin')">{{lang=="ru"?"Close test":"Close test"}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <b-modal v-model="confirmTest">
        <p style='text-align: center;'>
            {{lang=="ru"?"Пожалуйста, проверьте свой счет Binance на предмет открытия сделки. Если все прошло успешно, пожалуйста, нажмите кнопку «Close Test», чтобы закрыть позицию." : "Please check your Binance account about opened a trade. If everything success, please press button «Close Test» for close the position."}}
        </p>
        <template v-slot:modal-footer="{cancel}">
            <b-button @click="cancel()">{{lang=="ru"?"Хорошо":"OK"}}</b-button>
        </template>
  </b-modal>
</div>
</template>

<script>
import SimpleModal from 'simple-modal-vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import LanguagesDropdown from 'vue-languages-dropdown'
export default {
    components: {
        SimpleModal,
        Loading,
        'languages-dropdown' : LanguagesDropdown
    },
    data () {
        return {
            confirmTest: false,
            lang: 'en',
            isLoading: false,
            fullPage: true,
            isShow: false,
            loaded: false,
            yandexModal: false,
            refillAmount: 10,
            latestRefills: [],
            success_yan_url: '',
            amount: '',
            currency: '',
            password: {
                old: '',
                new: '',
                new2: ''
            },
            binance: {
                pubkey: '',
                privkey: '',
                refillBnb: true
            },
            FTX: {
                pubkey: '',
                privkey: '',
                refillBnb: true
            },
            OKX: {
                pubkey: '',
                privkey: '',
                passphare: '',
                refillBnb: true
            },
            Kucoin: {
                pubkey: '',
                privkey: '',
                passphare: '',
                refillBnb: true
            },
            KucoinFuture: {
                pubkey: '',
                privkey: '',
                passphare: '',
                refillBnb: true
            },
            passwordUpdateError: null,
            selectedList : ['ru', 'en'],
            kucoin_type: 's',
            test_buy_binance: true,
            short_test_buy_binance: true,
            test_buy_ftx: true,
            short_test_buy_ftx: true,
            test_buy_okx: true,
            short_test_buy_okx: true,
            test_buy_kucoin: true,
            short_test_buy_kucoin: true,
        }
    },

    created () {
        this.lang = this.$cookie.get('lang')
        this.axios.get('/user/latest_refills', {
                withCredentials: true
            })
            .then((response) => {
                this.latestRefills = response.data.refills
            })
        this.axios.get('/subscription/check_test_buy', {withCredentials: true}).then((response) => {
            this.test_buy_binance = response.data.binance
            this.test_buy_ftx = response.data.ftx
            this.test_buy_okx = response.data.okx
            this.test_buy_kucoin = response.data.kucoin
            
        })
        this.axios.get('/subscription/short_check_test_buy', {withCredentials: true}).then((response) => {
            this.short_test_buy_binance = response.data.binance
            this.short_test_buy_ftx = response.data.ftx
            this.short_test_buy_okx = response.data.okx
            this.short_test_buy_kucoin = response.data.kucoin
        })
    },
    methods: {
        get_staus () {
            this.axios.get('/subscription/check_test_buy', {withCredentials: true}).then((response) => {
                this.test_buy_binance = response.data.binance
                this.test_buy_ftx = response.data.ftx
                this.test_buy_okx = response.data.okx
                this.test_buy_kucoin = response.data.kucoin
                
            })
            this.axios.get('/subscription/short_check_test_buy', {withCredentials: true}).then((response) => {
                this.short_test_buy_binance = response.data.binance
                this.short_test_buy_ftx = response.data.ftx
                this.short_test_buy_okx = response.data.okx
                this.short_test_buy_kucoin = response.data.kucoin
            })
        },
        change_type (key) {
            this.kucoin_type = key
        },
        key_test () {
            this.axios.post('/subscription/test_key', {
                test_flag: this.test_buy_binance
            }, {
                withCredentials: true
            }).then(response => {
                console.log(response)
                if(response.data.result.error){
                    this.$root.$bvToast.toast(response.data.result.error, {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                    this.$root.$bvToast.toast(this.lang=='ru'?'Everything good, your API key is correct !':'Everything good, your API key is correct !', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                    if(this.test_buy){
                        this.confirmTest = true
                    }
                    this.get_staus()
                }
            })
        },
        ftx_key_test () {
            this.axios.post('/subscription/ftx_test_key', {
                test_flag: this.test_buy_ftx
            }, {
                withCredentials: true
            }).then(response => {
                console.log(response)
                if(response.data.result.error){
                    this.$root.$bvToast.toast(response.data.result.error, {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                    this.$root.$bvToast.toast(this.lang=='ru'?'Everything good, your API key is correct !':'Everything good, your API key is correct !', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                    if (this.test_buy) {
                        this.confirmTest = true
                    }
                    this.get_staus()
                }
            })
        },

        api_key_test (key) {
            let url = '';
            let flag_key = true
            if (key == 'okx') {
                url = '/subscription/okx_test_key'
                flag_key = this.test_buy_okx
            } else if (key === 'kucoin'){
                url = '/subscription/kucoin_test_key'
                flag_key = this.test_buy_kucoin
            }
            this.axios.post(url, {
                test_flag: flag_key
            }, {
                withCredentials: true
            }).then(response => {
                console.log("=======================");
                console.log(response)
                if(response.data.result.code == '1'){
                    this.$root.$bvToast.toast(response.data.result.data[0].sMsg, {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else if(response.data.result.code > 1 && response.data.result.code!=='200000'){
                    this.$root.$bvToast.toast(response.data.result.msg, {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                    this.$root.$bvToast.toast(this.lang=='ru'?'Everything good, your API key is correct !':'Everything good, your API key is correct !', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                    if (this.test_buy) {
                        this.confirmTest = true
                    }
                    this.get_staus()
                }
            })
        },

        short_key_test (key) {
            let flag_key = true

            let url = ''
            if (key === 'ftx') {
                flag_key = this.short_test_buy_ftx
                url = '/subscription/ftx_short_test_key'
            }else if ( key === 'okx') {
                flag_key = this.short_test_buy_okx
                url = '/subscription/okx_short_test_key'
            }else if ( key === 'kucoin') {
                flag_key = this.short_test_buy_kucoin
                url = '/subscription/kucoin_short_test_key'
            }
            else if ( key === 'binance') {
                flag_key = this.short_test_buy_binance
                url = '/subscription/short_test_key'
            }
            this.axios.post(url, {
                test_flag : flag_key
            }, {
                withCredentials: true
            }).then(response => {
                console.log(response)
                if(response.data.result.code == '1'){
                    this.$root.$bvToast.toast(response.data.result.data[0].sMsg, {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else if(response.data.result.code > 1 && response.data.result.code !='200000'){
                    this.$root.$bvToast.toast(response.data.result.msg, {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                    this.$root.$bvToast.toast(this.lang=='ru'?'Everything good, your API key is correct !':'Everything good, your API key is correct !', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                    if(this.short_test_buy){
                        this.confirmTest = true
                    }
                    this.get_staus();
                }
            })
        },
        optionSelected: function (data) {
            this.axios.post('/user/update_lang', {
                lang: data.code
            }, {
                withCredentials: true
            }).then(response => {
                console.log("=====lang result=====");
                console.log(response)
                document.cookie = 'lang=' + data.code + ';path=/;domain=tradingapp.pro;'
                window.location.reload();
            })
        },
        saveNewPassword() {
            this.passwordUpdateError = null
            this.axios.post('/user/update_password', {
                old_password: this.$parent.login_type === 'google' ? '1234' : this.password.old,
                new_password: this.password.new,
                new_password2: this.password.new2,
                email:this.$parent.alert_email
            }, {
                withCredentials: true
            }).then(response => {
                if (response.data.success) {
                    document.cookie = 'token=;path=/;domain=tradingapp.pro'
                    document.cookie = 'updated=true;path=/;domain=tradingapp.pro'

                    this.$router.push('/mail-sent')
                    // this.$root.$bvToast.toast('Password updated!', {
                    //     title: 'Notification',
                    //     variant: 'success',
                    //     solid: true
                    // })
                } else {
                    this.passwordUpdateError = response.data.message
                }
                console.log(response.data);
            })
            // this.passwordUpdateError = null
            // if(this.password.new2!=this.password.new){
            //     this.passwordUpdateError ="Пароли не совпадают";
            //     return false;
            // }
            // this.axios.get('/send_password_reset_link', {params: {email: $parent.alert_email}})
            //     .then((response) => {
            //     response = response.data
            //     console.log(response)
            //     if (response.success) {
            //         this.$router.push('/mail-sent')
            //     } else {
            //         this.errorText = response.message
            //     }
            // })
        },
        saveAlertEmail() {
            this.axios.post('/user/update_alert_email', {
                alert_email: this.$parent.alert_email
            }, {
                withCredentials: true
            }).then(response => {
                this.$parent.refresh_user_info()
                this.$root.$bvToast.toast(this.lang=='ru'?'Уведомление по электронной почте обновлено!':'Alert email updated!', {
                    title: this.lang=='ru'?'Уведомление ':'Notification',
                    variant: 'success',
                    solid: true
                })
                console.log(response.data)
            })
        },
        connectTelegram() {

        },

        disconnectTelegram() {
            this.axios.post('/user/unlink_telegram', {}, {
                withCredentials: true
            }).then(response => {
                this.$parent.refresh_user_info()
                this.$root.$bvToast.toast(this.lang=='ru'?'Telegram отключен!':'Telegram unlinked!', {
                    title: this.lang=='ru'?'Уведомление ':'Notification',
                    variant: 'success',
                    solid: true
                })
                console.log(response.data)
            })
        },

        removeBinanceKeys() {
            this.axios.post('/user/unlink_binance', {}, {
                withCredentials: true
            }).then(response => {
        this.$parent.refresh_user_info()
        this.$root.$bvToast.toast(this.lang =='ru'?'Ключи удалены!':'Keys removed!', {
            title: this.lang =='ru' ? 'Уведомление ':'Notification',
            variant: 'success',
            solid: true
        })
        console.log(response.data)
            })
        },

        removeFTXKeys () {
            this.axios.post('/user/unlink_FTX', {}, {
                withCredentials: true
            }).then(response => {
                this.$parent.refresh_user_info()
                this.$root.$bvToast.toast(this.lang === 'ru' ? 'Ключи удалены!' : 'Keys removed!', {
                    title: this.lang === 'ru' ? 'Уведомление' : 'Notification',
                    variant: 'success',
                    solid: true
                })
            })
        },

        removeOKXKeys () {
            this.axios.post('/user/unlink_OKX', {}, {
                withCredentials: true
            }).then(response => {
                this.$parent.refresh_user_info()
                this.$root.$bvToast.toast(this.lang === 'ru' ? 'Ключи удалены!' : 'Keys removed!', {
                    title: this.lang === 'ru' ? 'Уведомление' : 'Notification',
                    variant: 'success',
                    solid: true
                })
            })
        },

        removeKucoinKeys () {
            this.axios.post('/user/unlink_Kucoin', {}, {
                withCredentials: true
            }).then(response => {
                this.$parent.refresh_user_info()
                this.$root.$bvToast.toast(this.lang === 'ru' ? 'Ключи удалены!' : 'Keys removed!', {
                    title: this.lang === 'ru' ? 'Уведомление' : 'Notification',
                    variant: 'success',
                    solid: true
                })
            })
        },

        removeKucoinFutureKeys () {
            this.axios.post('/user/unlink_Kucoin_future', {}, {
                withCredentials: true
            }).then(response => {
                this.$parent.refresh_user_info()
                this.$root.$bvToast.toast(this.lang === 'ru' ? 'Ключи удалены!' : 'Keys removed!', {
                    title: this.lang === 'ru' ? 'Уведомление' : 'Notification',
                    variant: 'success',
                    solid: true
                })
            })
        },
        
        saveBinanceKeys() {
            if (this.$parent.binance_keys ==false && (this.binance.pubkey==null ||this.binance.pubkey.length !=64||this.binance.pubkey=='' ||this.binance.privkey==null ||this.binance.privkey==''||this.binance.privkey.length!=64)){
                this.$root.$bvToast.toast(this.lang ==='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys !', {
                    title: this.lang=='ru'?'Уведомление ':'Notification',
                    variant: 'warning',
                    solid: true
                })
                return false;
            }
            this.axios.post('/user/update_binance_keys', {
                binance_pubkey: this.binance.pubkey,
                binance_privkey: this.binance.privkey,
                refill_bnb: this.binance.refillBnb
            }, {
                withCredentials: true
            }).then(response => {
                if(this.$parent.binance_keys==false && response.data.success==true){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Ключи Binance сохранены!':'Binance keys saved!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }else if(this.$parent.binance_keys==false && response.data.success==false){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                        this.$root.$bvToast.toast(this.lang=='ru'?'Ключи Binance уже существуют!':'Binance keys are exist already!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }

                this.$parent.refresh_user_info()
                console.log(response.data)
            })
        },

        saveFTXKeys() {
            if (this.$parent.FTX_keys == false && (this.FTX.pubkey==null || this.FTX.pubkey=='' ||this.FTX.privkey==null ||this.FTX.privkey=='')){
                this.$root.$bvToast.toast(this.lang ==='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys !', {
                    title: this.lang=='ru'?'Уведомление ':'Notification',
                    variant: 'warning',
                    solid: true
                })
                return false;
            }
            this.axios.post('/user/update_FTX_keys', {
                FTX_pubkey: this.FTX.pubkey,
                FTX_privkey: this.FTX.privkey,
                refill_bnb: this.FTX.refillBnb
            }, {
                withCredentials: true
            }).then(response => {
                if(this.$parent.FTX_keys==false && response.data.success==true){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Ключи FTX сохранены!':'FTX keys saved!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }else if(this.$parent.FTX_keys==false && response.data.success==false){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                        this.$root.$bvToast.toast(this.lang=='ru'?'Ключи FTX уже существуют!':'FTX keys are exist already!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }

                this.$parent.refresh_user_info()
                console.log(response.data)
            })
        },

        saveOKXKeys() {
            if (this.$parent.OKX_keys == false && (this.OKX.pubkey==null || this.OKX.pubkey=='' ||this.OKX.privkey==null ||this.OKX.privkey=='' || this.OKX.passphare==null ||this.OKX.passphare=='')){
                this.$root.$bvToast.toast(this.lang ==='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys !', {
                    title: this.lang=='ru'?'Уведомление ':'Notification',
                    variant: 'warning',
                    solid: true
                })
                return false;
            }
            this.axios.post('/user/update_OKX_keys', {
                OKX_pubkey: this.OKX.pubkey,
                OKX_privkey: this.OKX.privkey,
                OKX_passphare: this.OKX.passphare,
                refill_bnb: this.OKX.refillBnb
            }, {
                withCredentials: true
            }).then(response => {
                if(this.$parent.OKX_keys==false && response.data.success==true){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Ключи OKX сохранены!':'OKX keys saved!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }else if(this.$parent.OKX_keys==false && response.data.success==false){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                        this.$root.$bvToast.toast(this.lang=='ru'?'Ключи OKX уже существуют!':'OKX keys are exist already!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }

                this.$parent.refresh_user_info()
                console.log(response.data)
            })
        },

        saveKucoinKeys() {
            if (this.$parent.Kucoin_keys == false && (this.Kucoin.pubkey==null || this.Kucoin.pubkey=='' ||this.Kucoin.privkey==null ||this.Kucoin.privkey=='' ||this.Kucoin.passphare==null ||this.Kucoin.passphare=='')){
                this.$root.$bvToast.toast(this.lang ==='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys !', {
                    title: this.lang=='ru'?'Уведомление ':'Notification',
                    variant: 'warning',
                    solid: true
                })
                return false;
            }
            this.axios.post('/user/update_Kucoin_keys', {
                Kucoin_pubkey: this.Kucoin.pubkey,
                Kucoin_privkey: this.Kucoin.privkey,
                Kucoin_passphare: this.Kucoin.passphare,
                refill_bnb: this.Kucoin.refillBnb
            }, {
                withCredentials: true
            }).then(response => {
                if(this.$parent.Kucoin_keys==false && response.data.success==true){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Ключи Kucoin сохранены!':'Kucoin keys saved!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }else if(this.$parent.Kucoin_keys==false && response.data.success==false){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                        this.$root.$bvToast.toast(this.lang=='ru'?'Ключи Kucoin уже существуют!':'Kucoin keys are exist already!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }

                this.$parent.refresh_user_info()
                console.log(response.data)
            })
        },

        saveKucoinFutureKeys() {
            if (this.$parent.Kucoin_future_keys == false && (this.KucoinFuture.pubkey==null || this.KucoinFuture.pubkey=='' ||this.KucoinFuture.privkey==null ||this.KucoinFuture.privkey=='' ||this.KucoinFuture.passphare==null ||this.KucoinFuture.passphare=='')){
                this.$root.$bvToast.toast(this.lang ==='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys !', {
                    title: this.lang=='ru'?'Уведомление ':'Notification',
                    variant: 'warning',
                    solid: true
                })
                return false;
            }
            this.axios.post('/user/update_Kucoin_future_keys', {
                Kucoin_future_pubkey: this.KucoinFuture.pubkey,
                Kucoin_future_privkey: this.KucoinFuture.privkey,
                Kucoin_future_passphare: this.KucoinFuture.passphare,
                refill_bnb: this.KucoinFuture.refillBnb
            }, {
                withCredentials: true
            }).then(response => {
                if(this.$parent.Kucoin_future_keys==false && response.data.success==true){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Ключи Kucoin сохранены!':'Kucoin Future keys saved!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }else if(this.$parent.Kucoin_keys==false && response.data.success==false){
                    this.$root.$bvToast.toast(this.lang=='ru'?'Пожалуйста, добавьте правильные ключи API':'Please add the  correct API keys', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'warning',
                        solid: true
                    })
                }else{
                        this.$root.$bvToast.toast(this.lang=='ru'?'Ключи Kucoin уже существуют!':'Kucoin keys are exist already!', {
                        title: this.lang=='ru'?'Уведомление ':'Notification',
                        variant: 'success',
                        solid: true
                    })
                }

                this.$parent.refresh_user_info()
                console.log(response.data)
            })
        }
        
    }
}
</script>

<style lang="css" scoped>
    .payment-button{
        margin-top: 10px;
    }
    .form-check-primary{
        display: none !important;
    }
    .unlink{
        display: inherit !important;
        margin-bottom: 1rem !important;
    }
    .card {
        height: 380px !important;
    }
    @media (max-width: 576px){
        .card {
            height: 500px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SettingsView.vue